export * from './domain-edit-template';